import React, { useState, useEffect } from 'react'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import { MessagingDialog } from '../messagingDialog/messagingDialog'
import { useGetAdminNotificationsQuery } from './messagingSlice'
import { MessageDetails } from '../messageDetails/messageDetails'
import { MessageDetail } from '../../utils/types'
import './messaging.scss'
import {
    selectCurrentEmpid,
} from '../../pages/login/authSlice';

export const Messaging = () => {
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [dialogVisible, setDialogVisible] = useState(false);
    const [header, setHeader] = useState('New Message');
    const [adminNotifications, setAdminNotification] = useState<any>([]);
    const [adminNotificationBackUp, setAdminNotificationBackup] = useState<any>([]);
    const loggedUser = useSelector(selectCurrentEmpid);
    const { data: adminNotificationData } = useGetAdminNotificationsQuery();
    const [selectedMessage, setSelectedMessage] = useState<MessageDetail | undefined>();

    useEffect(() => {
        setAdminNotification(adminNotificationData?.data?.length > 0 ? adminNotificationData.data : [])
        setAdminNotificationBackup(adminNotificationData?.data?.length > 0 ? adminNotificationData.data : [])
    }, [adminNotificationData]);


    const showDialog = () => {
        setDialogVisible(true);
    };

    const handleNewMessage = async () => {
        await setSelectedMessage(undefined)
        setHeader('New Message')
        showDialog()
    }

    const hideDialog = () => {
        setDialogVisible(false);
    };

    const onGlobalFilterChange = (e: any) => {
        setGlobalFilterValue(e.target.value);
        const searchTextLowerCase = e.target.value.toLowerCase();
        const filterData = adminNotificationBackUp.filter((item: any) =>
            item.template_subject.toLowerCase().includes(searchTextLowerCase) ||
            item.template_body.toLowerCase().includes(searchTextLowerCase)
        );

        setAdminNotification(filterData)
    };

    const handleSelect = (notification: MessageDetail) => {
        setSelectedMessage(notification)
        setHeader('Edit Message')
        showDialog()
    }
    return (
        <>
            <h3 className='margin-top-20'>Empower 2.0 Messages</h3>
            <div className=' margin-top-20'>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                    />
                </span>
                <Button
                    type="button"
                    icon="pi pi-plus me-2"
                    className="btn-primary mr-2 me-2 float-end"
                    // style={{ backgroundColor: '#007bff', color: '#fff' }}
                    onClick={handleNewMessage}
                >
                    New Message
                </Button>
                <div className='container-message'>
                    {adminNotifications.length > 0 && adminNotifications.map((notification: any) => {
                        return (
                            <React.Fragment  key={notification.notification_template_id} >
                                <MessageDetails onSelect={handleSelect} notification={notification} />
                                <hr />
                            </React.Fragment>
                        )
                    })}
                </div>
                <MessagingDialog existingData = {adminNotificationBackUp} header = {header} messageDetails={selectedMessage} employeeNumber={loggedUser} visible={dialogVisible} onHide={hideDialog} />
            </div>

        </>

    )
}